import { useTheme, useMediaQuery } from "@mui/material";

// True on phone-sized screens (< 600px), where content/edit dialogs should fill
// the screen instead of floating as an overlay, to make best use of the space.
// Larger screens keep the centred overlay. Shared by every substantial dialog;
// small yes/no confirmation dialogs deliberately stay compact.
export function useFullScreenDialog() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("sm"));
}
